module.exports = __webpack_public_path__ + "img/stars.8fd872a0.png";